import { CadastroFiscalDefinicao } from "./ParametrosFiscais";

export const cadastrosFiscais: CadastroFiscalDefinicao[] = [
  {
    "nome": "unidadeOrganizacionalParametroFiscalEstado",
    "label": "Parâmetros fiscais por estado",
    "campos": [
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "icmsSaidaContribuinte",
        "label": "ICMS Saída Contribuinte (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsSaidaNaoContribuinte",
        "label": "ICMS Saída Não Contribuinte (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsInterestadualImportado",
        "label": "ICMS Interestadual Importado (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsInternoDestino",
        "label": "ICMS Interno Destino (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "fcp",
        "label": "FCP (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "fcpUfDestino",
        "label": "FCP UF Destino (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "modalidadeBaseDifal",
        "label": "Modalidade Base Difal",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "SIMPLES",
            "label": "Base simples"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "transacaoNotaFiscalNaturezaOperacao",
    "label": "Transação × natureza de operação",
    "campos": [
      {
        "nome": "idTransacaoNotaFiscal",
        "label": "Transação Nota Fiscal",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "transacaoNotaFiscal"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "indicadorIeDestinatario",
        "label": "Indicador IE Destinatário",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "1",
            "label": "Contribuinte"
          },
          {
            "value": "2",
            "label": "Contribuinte isento"
          },
          {
            "value": "9",
            "label": "Não contribuinte"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "consumidorFinal",
        "label": "Consumidor Final",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "0",
            "label": "Normal"
          },
          {
            "value": "1",
            "label": "Consumidor final"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "cfop",
        "label": "CFOP",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 4
      },
      {
        "nome": "naturezaOperacao",
        "label": "Natureza Operação",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "situacaoTributaria",
    "label": "Situações tributárias",
    "campos": [
      {
        "nome": "situacaoTributaria",
        "label": "Código",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "descricaoSituacaoTributaria",
        "label": "Descrição Situação Tributária",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "cstIcms",
        "label": "CST ICMS",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 2
      },
      {
        "nome": "modalidadeBaseIcms",
        "label": "Modalidade Base ICMS",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "3",
            "label": "Valor da operação"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "motivoDesoneracao",
        "label": "Motivo Desoneração",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "modalidadeDesoneracao",
        "label": "Modalidade Desoneração",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "deduzDesoneracaoTotal",
        "label": "Deduz Desoneração Total",
        "obrigatorio": false,
        "tipo": "boolean"
      },
      {
        "nome": "observacaoFiscal",
        "label": "Observação Fiscal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "icmsEspecial",
    "label": "ICMS especial",
    "campos": [
      {
        "nome": "icmsEspecial",
        "label": "Código",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "descricaoIcmsEspecial",
        "label": "Descrição ICMS Especial",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "icmsEspecialEstado",
    "label": "ICMS especial por estado",
    "campos": [
      {
        "nome": "idIcmsEspecial",
        "label": "ICMS Especial",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "icmsEspecial"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "icmsSaidaContribuinte",
        "label": "ICMS Saída Contribuinte (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsSaidaNaoContribuinte",
        "label": "ICMS Saída Não Contribuinte (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsInterestadualImportado",
        "label": "ICMS Interestadual Importado (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "icmsInternoDestino",
        "label": "ICMS Interno Destino (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "fcp",
        "label": "FCP (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "fcpUfDestino",
        "label": "FCP UF Destino (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "observacaoFiscal",
        "label": "Observação Fiscal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "reducaoImposto",
    "label": "Redução de impostos",
    "campos": [
      {
        "nome": "reducaoImposto",
        "label": "Código",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "descricaoReducaoImposto",
        "label": "Descrição Redução Imposto",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "reducaoImpostoEstado",
    "label": "Redução de impostos por estado",
    "campos": [
      {
        "nome": "idReducaoImposto",
        "label": "Redução Imposto",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "reducaoImposto"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "tributo",
        "label": "Tributo",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "ICMS",
            "label": "ICMS"
          },
          {
            "value": "IPI",
            "label": "IPI"
          },
          {
            "value": "PIS",
            "label": "PIS"
          },
          {
            "value": "COFINS",
            "label": "COFINS"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "indicadorIeDestinatario",
        "label": "Indicador IE Destinatário",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "1",
            "label": "Contribuinte"
          },
          {
            "value": "2",
            "label": "Contribuinte isento"
          },
          {
            "value": "9",
            "label": "Não contribuinte"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "reducaoBase",
        "label": "Redução Base (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "reducaoAliquota",
        "label": "Redução Alíquota (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "observacaoFiscal",
        "label": "Observação Fiscal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "substituicaoTributaria",
    "label": "Substituição tributária",
    "campos": [
      {
        "nome": "substituicaoTributaria",
        "label": "Código",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "descricaoSubstituicaoTributaria",
        "label": "Descrição Substituição Tributária",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "substituicaoTributariaEstado",
    "label": "Substituição tributária por estado",
    "campos": [
      {
        "nome": "idSubstituicaoTributaria",
        "label": "Substituição Tributária",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "substituicaoTributaria"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "modalidadeBaseIcmsSt",
        "label": "Modalidade Base ICMS ST",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "4",
            "label": "Margem de valor agregado"
          },
          {
            "value": "5",
            "label": "Pauta"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "mva",
        "label": "MVA (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": false
      },
      {
        "nome": "ajustaMva",
        "label": "Ajusta MVA",
        "obrigatorio": false,
        "tipo": "boolean"
      },
      {
        "nome": "icmsInternoDestino",
        "label": "ICMS Interno Destino (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "reducaoBaseIcmsSt",
        "label": "Redução Base ICMS ST (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "fcpSt",
        "label": "FCP ST (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "pautaUnitaria",
        "label": "Pauta Unitária",
        "obrigatorio": false,
        "tipo": "numero"
      },
      {
        "nome": "unidadePauta",
        "label": "Unidade Pauta",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "observacaoFiscal",
        "label": "Observação Fiscal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "dispositivoFiscal",
    "label": "Dispositivos fiscais",
    "campos": [
      {
        "nome": "dispositivoFiscal",
        "label": "Código",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "descricaoDispositivoFiscal",
        "label": "Descrição Dispositivo Fiscal",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "uf",
        "label": "Uf",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "fundamentoLegal",
        "label": "Fundamento Legal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "textoNota",
        "label": "Texto Nota",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "beneficioFiscal",
        "label": "Benefício Fiscal",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "beneficioReducaoBase",
        "label": "Benefício Redução Base",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "beneficioCreditoPresumido",
        "label": "Benefício Crédito Presumido",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "motivoDesoneracao",
        "label": "Motivo Desoneração",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "situacaoTributariaDispositivoFiscal",
    "label": "Situação tributária × dispositivo fiscal",
    "campos": [
      {
        "nome": "idSituacaoTributaria",
        "label": "Situação Tributária",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "situacaoTributaria"
      },
      {
        "nome": "idDispositivoFiscal",
        "label": "Dispositivo Fiscal",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "dispositivoFiscal"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "ufDestino",
        "label": "UF Destino",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "idClassificacaoFiscal",
        "label": "Classificação Fiscal",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "classificacaoFiscal"
      },
      {
        "nome": "idTransacaoNotaFiscal",
        "label": "Transação Nota Fiscal",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "transacaoNotaFiscal"
      },
      {
        "nome": "cdProduto",
        "label": "Produto",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "produto",
        "tamanho": 20
      },
      {
        "nome": "informaSemBeneficio",
        "label": "Informa Sem Benefício",
        "obrigatorio": false,
        "tipo": "boolean"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "produtoUnidadeOrganizacionalFiscal",
    "label": "Produto × unidade organizacional",
    "campos": [
      {
        "nome": "cdProduto",
        "label": "Produto",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "produto",
        "tamanho": 20
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "idClassificacaoFiscal",
        "label": "Classificação Fiscal",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "classificacaoFiscal"
      },
      {
        "nome": "idSituacaoTributaria",
        "label": "Situação Tributária",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "situacaoTributaria"
      },
      {
        "nome": "idIcmsEspecial",
        "label": "ICMS Especial",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "icmsEspecial"
      },
      {
        "nome": "idReducaoImposto",
        "label": "Redução Imposto",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "reducaoImposto"
      },
      {
        "nome": "idSubstituicaoTributaria",
        "label": "Substituição Tributária",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "substituicaoTributaria"
      },
      {
        "nome": "idDispositivoFiscal",
        "label": "Dispositivo Fiscal",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "dispositivoFiscal"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "classificacaoFiscalPisCofins",
    "label": "Classificação fiscal — PIS/COFINS",
    "campos": [
      {
        "nome": "idClassificacaoFiscal",
        "label": "Classificação Fiscal",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "classificacaoFiscal"
      },
      {
        "nome": "regimePisCofins",
        "label": "Regime PIS COFINS",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "CUMULATIVO",
            "label": "Cumulativo"
          },
          {
            "value": "NAO_CUMULATIVO",
            "label": "Não cumulativo"
          },
          {
            "value": "MISTO",
            "label": "Misto"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "cstPis",
        "label": "CST PIS",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 2
      },
      {
        "nome": "cstCofins",
        "label": "CST COFINS",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 2
      },
      {
        "nome": "modalidadeCalculoPis",
        "label": "Modalidade Cálculo PIS",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "PERCENTUAL",
            "label": "Percentual"
          },
          {
            "value": "QUANTIDADE",
            "label": "Quantidade"
          },
          {
            "value": "NAO_TRIBUTADO",
            "label": "Não tributado"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "modalidadeCalculoCofins",
        "label": "Modalidade Cálculo COFINS",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "PERCENTUAL",
            "label": "Percentual"
          },
          {
            "value": "QUANTIDADE",
            "label": "Quantidade"
          },
          {
            "value": "NAO_TRIBUTADO",
            "label": "Não tributado"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "aliquotaPis",
        "label": "Alíquota PIS (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "aliquotaCofins",
        "label": "Alíquota COFINS (%)",
        "obrigatorio": false,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "aliquotaUnitariaPis",
        "label": "Alíquota Unitária PIS",
        "obrigatorio": false,
        "tipo": "numero"
      },
      {
        "nome": "aliquotaUnitariaCofins",
        "label": "Alíquota Unitária COFINS",
        "obrigatorio": false,
        "tipo": "numero"
      },
      {
        "nome": "unidadeCalculo",
        "label": "Unidade Cálculo",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "observacaoFiscal",
        "label": "Observação Fiscal",
        "obrigatorio": false,
        "tipo": "texto"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "classificacaoTributariaIbsCbs",
    "label": "Classificações tributárias — IBS/CBS",
    "campos": [
      {
        "nome": "cstIbsCbs",
        "label": "CST IBS CBS",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 3
      },
      {
        "nome": "classificacaoTributaria",
        "label": "Classificação Tributária",
        "obrigatorio": true,
        "tipo": "texto",
        "tamanho": 6
      },
      {
        "nome": "descricaoClassificacaoTributaria",
        "label": "Descrição Classificação Tributária",
        "obrigatorio": true,
        "tipo": "texto"
      },
      {
        "nome": "modalidadeTributacao",
        "label": "Modalidade Tributação",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "PERCENTUAL",
            "label": "Percentual"
          },
          {
            "value": "NAO_TRIBUTADO",
            "label": "Não tributado"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "reducaoIbs",
        "label": "Redução IBS (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "reducaoCbs",
        "label": "Redução CBS (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "permiteDiferimento",
        "label": "Permite Diferimento",
        "obrigatorio": false,
        "tipo": "boolean"
      },
      {
        "nome": "permiteCreditoPresumido",
        "label": "Permite Crédito Presumido",
        "obrigatorio": false,
        "tipo": "boolean"
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "classificacaoFiscalIbsCbsLigacao",
    "label": "Classificação fiscal × IBS/CBS",
    "campos": [
      {
        "nome": "idClassificacaoTributariaIbsCbs",
        "label": "Classificação Tributária IBS CBS",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "classificacaoTributariaIbsCbs"
      },
      {
        "nome": "idUnidadeOrganizacional",
        "label": "Unidade Organizacional",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "unidadeOrganizacional"
      },
      {
        "nome": "idClassificacaoFiscal",
        "label": "Classificação Fiscal",
        "obrigatorio": true,
        "tipo": "referencia",
        "referencia": "classificacaoFiscal"
      },
      {
        "nome": "idTransacaoNotaFiscal",
        "label": "Transação Nota Fiscal",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "transacaoNotaFiscal"
      },
      {
        "nome": "cdProduto",
        "label": "Produto",
        "obrigatorio": false,
        "tipo": "referencia",
        "referencia": "produto",
        "tamanho": 20
      },
      {
        "nome": "cfop",
        "label": "CFOP",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 4
      },
      {
        "nome": "origemMercadoria",
        "label": "Origem Mercadoria",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 20
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  },
  {
    "nome": "ibsCbsAliquota",
    "label": "Alíquotas de IBS/CBS",
    "campos": [
      {
        "nome": "tributo",
        "label": "Tributo",
        "obrigatorio": true,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "IBS_ESTADUAL",
            "label": "IBS ESTADUAL"
          },
          {
            "value": "IBS_MUNICIPAL",
            "label": "IBS MUNICIPAL"
          },
          {
            "value": "CBS",
            "label": "CBS"
          }
        ],
        "tamanho": 20
      },
      {
        "nome": "uf",
        "label": "Uf",
        "obrigatorio": false,
        "tipo": "referencia",
        "opcoes": [
          {
            "value": "AC",
            "label": "AC"
          },
          {
            "value": "AL",
            "label": "AL"
          },
          {
            "value": "AP",
            "label": "AP"
          },
          {
            "value": "AM",
            "label": "AM"
          },
          {
            "value": "BA",
            "label": "BA"
          },
          {
            "value": "CE",
            "label": "CE"
          },
          {
            "value": "DF",
            "label": "DF"
          },
          {
            "value": "ES",
            "label": "ES"
          },
          {
            "value": "GO",
            "label": "GO"
          },
          {
            "value": "MA",
            "label": "MA"
          },
          {
            "value": "MT",
            "label": "MT"
          },
          {
            "value": "MS",
            "label": "MS"
          },
          {
            "value": "MG",
            "label": "MG"
          },
          {
            "value": "PA",
            "label": "PA"
          },
          {
            "value": "PB",
            "label": "PB"
          },
          {
            "value": "PR",
            "label": "PR"
          },
          {
            "value": "PE",
            "label": "PE"
          },
          {
            "value": "PI",
            "label": "PI"
          },
          {
            "value": "RJ",
            "label": "RJ"
          },
          {
            "value": "RN",
            "label": "RN"
          },
          {
            "value": "RS",
            "label": "RS"
          },
          {
            "value": "RO",
            "label": "RO"
          },
          {
            "value": "RR",
            "label": "RR"
          },
          {
            "value": "SC",
            "label": "SC"
          },
          {
            "value": "SP",
            "label": "SP"
          },
          {
            "value": "SE",
            "label": "SE"
          },
          {
            "value": "TO",
            "label": "TO"
          }
        ],
        "tamanho": 2
      },
      {
        "nome": "municipioIbge",
        "label": "Município Ibge",
        "obrigatorio": false,
        "tipo": "texto",
        "tamanho": 7
      },
      {
        "nome": "aliquota",
        "label": "Aliquota (%)",
        "obrigatorio": true,
        "tipo": "numero",
        "percentual": true
      },
      {
        "nome": "inicioVigencia",
        "label": "Início Vigência",
        "obrigatorio": true,
        "tipo": "data"
      },
      {
        "nome": "fimVigencia",
        "label": "Fim Vigência",
        "obrigatorio": false,
        "tipo": "data"
      },
      {
        "nome": "ativo",
        "label": "Ativo",
        "obrigatorio": true,
        "tipo": "boolean"
      }
    ]
  }
];
